<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>老师反馈列表</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false" label-position="left">
        <Row :gutter="32">
          <Col :span="5">
            <Form-item label="老师ID" >
              <Input name="tchId" v-model="queryParam.tchId"/>
            </Form-item>
          </Col>
          <Col :span="5">
            <Form-item  label="老师姓名">
              <Input placeholder="支持模糊搜索" name="tchName" v-model="queryParam.tchName"/>
            </Form-item>
          </Col>
          <Col :span="5">
            <Form-item label="学生ID" >
              <Input name="tchId" v-model="queryParam.uid"/>
            </Form-item>
          </Col>
          <Col :span="5">
            <Form-item  label="学生昵称">
              <Input placeholder="支持模糊搜索" name="tchName" v-model="queryParam.nickname"/>
            </Form-item>
          </Col>
          <Col :span="2">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search" >搜索</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/bookTchFeedback/list"
          :params="queryParam" :onLoading="onLoading" operator=""></List>
  </div>
</template>
<script>
  import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
  export default {
    components: { },
    data () {
      let $constant = this.$constant
      return {
        searchLoading: false,
        rankScoreSeq: 0,
        reload: 0,
        tchId: null,
        queryParam: {
          tchId: '',
          tchName: '',
          uid: '',
          nickname: '',
        },
        title: [
          {
            title: '课次ID',
            align: 'center',
            width: 100,
            key: 'lsnOpenId'
          },
          {
            title: '老师',
            align: 'center',
            width: 180,
            render: (h, params) => {
              let row = params.row
              return renderTchNameWithScore(h, {
                text: row.tchId + '-' + row.tchName,
                score: row.monthRankScore,
                onClick: row.tchId ? () => this.openTchInfoModal(row.tchId) : null
              })
            }
          },
          {
            title: '学生',
            align: 'center',
            width: 150,
            render: (h, params) => {
              let row = params.row
              return h('span', row.uid + '-' + row.nickname)
            }
          },
          {
            title: '开课时间',
            align: 'center',
            width: 150,
            key: 'lsnBeginTimeStr'
          },
          {
            title: '课程类型',
            align: 'center',
            width: 100,
            render: (h, params) => {
              let lsnType = params.row.lsnType
              let lsnTypeEnum = $constant.getEnum($constant.bookLessonOpenedLsnType, lsnType)
              return h('span', lsnTypeEnum && lsnTypeEnum.text)
            }
          },
          {
            title: '课程类别',
            align: 'center',
            width: 100,
            render: (h, params) => {
              let courseType = params.row.courseType
              let courseTypeEnum = $constant.getEnum($constant.courseType, courseType)
              return h('span', courseTypeEnum && courseTypeEnum.text)
            }
          },
          {
            title: '课节ID',
            align: 'center',
            width: 80,
            key: 'lessonId'
          },
          {
            title: '课节标题',
            align: 'center',
            width: 200,
            key: 'title'
          },
          {
            title: '反馈时间',
            align: 'center',
            width: 170,
            key: 'createTimeStr'
          },
          {
            title: '学习内容的评论',
            align: 'center',
            width: 170,
            key: 'learnedComment'
          },
          {
            title: '表现好的评论',
            align: 'center',
            width: 170,
            key: 'goodComment'
          },
          {
            title: '可以改进的评论',
            align: 'center',
            width: 170,
            key: 'betterComment'
          },
          {
            title: '状态',
            width: 80,
            align: 'center',
            render: (h, params) => {
              let status = params.row.status
              let statusEnum = $constant.getEnum($constant.tchFeedbackStatus, status)
              return h('span', statusEnum && statusEnum.text)
            }
          },
          {
            title: '操作',
            align: 'center',
            width: 80,
            render: (h, params) => {
              let status = params.row.status
              if (status === 2) {
                return h('a', {on: { click: () => { this.onHideOrShow(params.row.lsnOpenId, 1, '显示') } }}, '显示')
              } else if (status === 1) {
                return h('a', {on: { click: () => { this.onHideOrShow(params.row.lsnOpenId, 2, '隐藏') } }}, '隐藏')
              }
            }
          }
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
    },
    methods: {
      openTchInfoModal (val) {
        this.tchId = val
        this.showTchInfoModal = true
      },
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
        if (!loading) {
          this.loadMonthRankScores()
        }
      },
      loadMonthRankScores () {
        const table = this.$refs.dataList && this.$refs.dataList.tableData
        if (!table || !table.length) {
          return
        }
        const ids = table.map(function (row) { return row.tchId }).filter(function (id) { return id != null })
        const seq = ++this.rankScoreSeq
        const self = this
        fetchTchScoreMap(this.$http, ids).then(function (map) {
          if (seq !== self.rankScoreSeq) {
            return
          }
          applyTchScoresToRows(self, table, 'tchId', 'monthRankScore', map)
        })
      },
      onHideOrShow (lsnOpenId, status, text) {
        this.$Modal.confirm({
          title: '提示',
          content: '确定' + text + '？',
          width: 300,
          loading: true,
          onOk: () => {
            this.$http.post('/bookTchFeedback/update', {lsnOpenId: lsnOpenId, status: status}).then(function (res) {
              this.search()
              this.$Message.success(text + '成功!')
              this.$Modal.remove()
            })
          }
        })
      },
    }
  }
</script>



// WEBPACK FOOTER //
// TchFeedbackList.vue?c47b5bb6